const actionCableUrl = process.env.REACT_APP_ACTION_CABLE_URL;
export default actionCableUrl;
